/* fonts */
export const bodyFont = `interface, Helvetica Neue, helvetica, sans-serif`
export const titleFont = `nexablack, sans-serif;`
